/**
 * Point d'entrée pour l'éditeur de texte riche
 */
export { RichEditor } from './RichEditor.js';
export { ListManager } from './ListManager.js';
export { KeyboardHandler } from './KeyboardHandler.js';
export { UndoRedoManager } from './UndoRedoManager.js';
export { EnhancedRichEditor } from './EnhancedRichEditor.js';

import { EnhancedRichEditor } from './EnhancedRichEditor.js';

/**
 * Initialise tous les éditeurs riches sur la page
 */
export function initializeRichEditors() {
    document.querySelectorAll('.arcate-input-rich').forEach(container => {
        new EnhancedRichEditor(container);
    });
}